/**
 * Join class name fragments, dropping falsy values. A deliberately tiny helper
 * (no `clsx` dependency) so every component composes class names the same way.
 */
export type ClassValue = string | number | false | null | undefined;

export function cn(...values: ClassValue[]): string {
  let out = '';
  for (const value of values) {
    if (!value && value !== 0) continue;
    out = out ? `${out} ${value}` : String(value);
  }
  return out;
}
